<div>
  <form [formGroup]="sezForm">
    <mat-card>
      <mat-card-content class="fx-row">
        <div class="check-size">
          <mat-checkbox formControlName="sez" (change)="setSezChangeValueEvent($event)" >SEZ</mat-checkbox>
        </div>
        @if (showSEZWefAndUpto) {
          <div class="fx-align-space-evenly-stretch">
            <mat-form-field class="date">
              <mat-label>SEZ WEF</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="sezWEFDate" placeholder="SEZ WEF" required autocomplete="off">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              @if (sezWEFDate.hasError('required') && sezWEFDate.touched && sezWEFDate.invalid) {
                <mat-error>WEF is required</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="date">
              <mat-label>SEZ Valid Upto</mat-label>
              <input matInput [matDatepicker]="picker1" formControlName="sezValidUptoDate" required placeholder="SEZ Valid Upto Date" autocomplete="off">
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              @if (sezValidUptoDate.hasError('required') && sezValidUptoDate.touched && sezValidUptoDate.invalid) {
                <mat-error>SEZ Valid Upto Date is required</mat-error>
              }
            </mat-form-field>
            <div class="upload">
              <input type="file" hidden #fileInput
                (change)="filesSelected($event.target['files'])"/>
                <mat-icon class="__upload_icon" (click)="fileInput.click()" style="cursor: pointer;color: green;">note_add</mat-icon>
                @if (sezDocument) {
                  <mat-icon class="__upload_icon" (click)="downloadFile()" style="cursor: pointer;color: red;">file_download</mat-icon>
                }
              </div>
            </div>
          }
        </mat-card-content>
        @if (!buttonHidden) {
          <mat-card-actions>
            <button mat-button color="primary" (click)="onSave()" style="width: 12%;margin-right: 10px;">Save</button>
            <button mat-button color="cancel" (click)="onCancel()" style="width: 12%;">Cancel</button>
          </mat-card-actions>
        }
      </mat-card>
    </form>
  </div>
